import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { nightsBetween } from 'uplisting-frontend/utils/date';

export enum AirbnbOfficialAlterationRequestStatus {
  pending = 'PENDING',
  accepted = 'ACCEPTED',
  declined = 'DECLINED',
  void = 'VOID',
  cancelled = 'CANCELED',
  awaiting_payment = 'AWAITING_PAYMENT',
}

export enum AirbnbOfficialAlterationRequestInitiatedBy {
  host = 'host',
  guest = 'guest',
}

export default class AirbnbOfficialAlterationRequestModel extends Model {
  @attr('string') status!: AirbnbOfficialAlterationRequestStatus;
  @attr('string') initiatedBy!: AirbnbOfficialAlterationRequestInitiatedBy;

  @attr('number') hostPayout!: number;
  @attr('number') guestPayment!: number;
  @attr('number') numberOfGuests!: number;

  // 'yyyy-MM-dd', like Booking's checkIn/checkOut
  @attr('string') startDate!: string;
  @attr('string') endDate!: string;
  @attr('date') requestedAt!: Date;

  @belongsTo('booking', {
    inverse: 'airbnbOfficialAlterationRequests',
    async: false,
  })
  booking!: ModelRegistry['booking'];

  @cached
  get isPending(): boolean {
    return this.status === AirbnbOfficialAlterationRequestStatus.pending;
  }

  @cached
  get isAccepted(): boolean {
    return this.status === AirbnbOfficialAlterationRequestStatus.accepted;
  }

  @cached
  get changeRequestedByHost(): boolean {
    return this.initiatedBy === AirbnbOfficialAlterationRequestInitiatedBy.host;
  }

  @cached
  get changeRequestedByGuest(): boolean {
    return (
      this.initiatedBy === AirbnbOfficialAlterationRequestInitiatedBy.guest
    );
  }

  @cached
  get duration(): number {
    return nightsBetween(this.startDate, this.endDate);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-alteration-request': AirbnbOfficialAlterationRequestModel;
  }
}
